import React from 'react';
import { PropertyGroup } from './PropertyGroup';

/**
 * Options property component for select/radio/checkbox fields
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const OptionsProperty = _ref => {
  let {
    field,
    updateOption,
    removeOption,
    addOption
  } = _ref;
  if (!['select', 'radio', 'checkbox'].includes(field.type)) {
    return null;
  }
  return /*#__PURE__*/_jsxs(PropertyGroup, {
    label: "Options",
    children: [/*#__PURE__*/_jsx("div", {
      className: "options-list",
      children: field.options?.map((option, index) => /*#__PURE__*/_jsxs("div", {
        className: "option-item",
        children: [/*#__PURE__*/_jsx("input", {
          type: "text",
          placeholder: "Label",
          value: option.label,
          onChange: e => updateOption(index, 'label', e.target.value),
          className: "option-input"
        }), /*#__PURE__*/_jsx("input", {
          type: "text",
          placeholder: "Value",
          value: option.value,
          onChange: e => updateOption(index, 'value', e.target.value),
          className: "option-input"
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: () => removeOption(index),
          className: "remove-option-btn",
          children: "\xD7"
        })]
      }, index))
    }), /*#__PURE__*/_jsx("button", {
      type: "button",
      onClick: addOption,
      className: "add-option-btn",
      children: "+ Add Option"
    })]
  });
};